import { Route } from '@angular/router';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { limitReportOtherDetails } from '@backoffice-frontend/limit-report/ui-other';

export const limitReportOtherRoute: Route = {
  path: '',
  children: [
    {
      path: '',
      loadChildren: () =>
        import('@backoffice-frontend/limit-report/ui-other').then(
          (mod) => mod.LimitReportOtherListModule
        ),
    },
    limitReportOtherDetails,
  ],
};
